import { ChartGender } from '@hr/dashboardview/cards/chartgender'
import { emptyCard } from '@hr/dashboardview/common'
import { DashboardCard } from '@hr/dashboardview/dashboardcard'
import { useState } from 'react'
import { Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { GenderDistribution } from './cards/GenderDistribution'
import { GroupGenderDistribution } from './cards/GroupGenderDistribution'
import { NumberOfEmployeeGroups } from './cards/NumberOfEmployeeGroups'
import { PayGapsGrouped } from './cards/PayGapsGrouped'
import { PersonnelCountSalary } from './cards/PersonnelCountSalary'
import { SalaryDiffAverage } from './cards/SalaryDiffAverage'
import { SalaryDiffMedian } from './cards/SalaryDiffMedian'
import { SalaryLevelsGrouped } from './cards/SalaryLevelsGrouped'

const localStorageKey = 'salaryDashboard'

function restoreState(availableCards) {
	const dashboardJson = localStorage.getItem(localStorageKey)

	if (dashboardJson !== null) {
		const restoredCards = JSON.parse(dashboardJson)
		const filteredCards = restoredCards.filter((card) => availableCards[card.name] !== undefined)
		return filteredCards.length === 0 ? [emptyCard()] : filteredCards
	}

	//DEFAULT
	return [
		{ name: 'PersonnelCount', size: 'lg' },
		{ name: 'GenderDistribution', size: 'lg' },
		{ name: 'GenderDistributionPercentage', size: 'lg' },
		{ name: 'NumberOfEmployeeGroups', size: 'lg' },
		{ name: 'GroupGenderDistribution', size: 'xl' },
		{ name: 'SalaryLevelsGrouped', size: 'xl' },
		{ name: 'PayGapsGrouped', size: 'xl' },
	]
}

export function SalaryDashboardTab() {
	const { t } = useTranslation()

	// key is a translation key
	const availableCards = (() => {
		const cards = {
			Empty: () => (
				<span className="opacity-50">({t('SelectItemToShowData', 'Valitse kohde näyttääksesi tiedot')})</span>
			),
			PersonnelCount: () => <PersonnelCountSalary />, // Henkilöstömäärä
			SalaryDiffAverage: () => <SalaryDiffAverage />, // Palkkaero % (keskiarvo)
			SalaryDiffMedian: () => <SalaryDiffMedian />, // Palkkaero % (mediaani)
			GenderDistribution: () => <GenderDistribution />, // Sukupuolijakauma
			GenderDistributionPercentage: () => <ChartGender />, // Sukupuolijakauma
			NumberOfEmployeeGroups: () => <NumberOfEmployeeGroups />, // Työntekijäryhmien lukumäärä
			GroupGenderDistribution: () => <GroupGenderDistribution />, // Työntekijäryhmät ja sukupuolijakauma
			SalaryLevelsGrouped: () => <SalaryLevelsGrouped />, // Palkkatasot työntekijäryhmittäin ja sukupuolittain
			PayGapsGrouped: () => <PayGapsGrouped />, // Palkkaeroindikaattori työntekijäryhmittäin
		}

		return cards
	})()

	const [cards, setCards] = useState(() => restoreState(availableCards))

	const compareFn = (a, b) => t(a) > t(b) // sort options by translations
	const cardOptions = Object.keys(availableCards)
		.sort(compareFn)
		.map((name) => (
			<option key={name} value={name}>
				{t(name)}
			</option>
		))

	return (
		<>
			<h2 className="viewheading">{t('CompensationSummary', 'Palkkayhteenveto')}</h2>

			<Row className="dashboard-cards">
				{cards.map((card, idx) => (
					<DashboardCard
						key={card.name}
						localStorageKey={localStorageKey}
						setCards={setCards}
						availableCards={availableCards}
						cardOptions={cardOptions}
						data={{
							...card,
							idx: idx,
						}}
					/>
				))}
			</Row>
		</>
	)
}
